export const schemeColumns = (openModal) => [
  {
    title: "Scheme Name",
    dataIndex: "scheme_name",
    key: "scheme_name",
    render: (text, record) =>
      openModal ? (
        <button
          style={{
            padding: 0,
            border: "none",
            background: "none",
            color: "#1677ff",
            cursor: "pointer",
            textAlign: "left",
            whiteSpace: "normal",      // ✅ allow multi-line
            wordBreak: "break-word",   // ✅ break long words if needed
          }}
          onClick={() => openModal(record)}
        >
          {text}
        </button>
      ) : (
        <span
          style={{
            whiteSpace: "normal",      // ✅ allow multi-line
            wordBreak: "break-word",
            display: "block",
            textAlign: "left",
          }}
        >
          {text}
        </span>
      ),
  },
  {
    title: "Scheme Code",
    dataIndex: "scheme_code",
    key: "scheme_code",
  },
  {
    title: "Total Investment",
    children: [
      {
        title: "Units",
        dataIndex: "total_units_credit",
        key: "total_units_credit",
        render: (v) => Number(v || 0).toLocaleString(undefined, { minimumFractionDigits: 4 }),
      },
      {
        title: "Amount",
        dataIndex: "total_investment",
        key: "total_investment",
        render: (v) => `₹${Number(v || 0).toLocaleString()}`,
      },
    ],
  },
  {
    title: "Redemption / Switches",
    children: [
      {
        title: "Units",
        dataIndex: "total_units_debit",
        key: "total_units_debit",
        render: (v) => Number(v || 0).toLocaleString(undefined, { minimumFractionDigits: 4 }),
      },
      {
        title: "Cost Amount",
        dataIndex: "redemption_cost_amount",
        key: "redemption_cost_amount",
        render: (v) => `₹${Number(v || 0).toLocaleString()}`,
      },
      {
        title: "Actual Amount",
        dataIndex: "redemption_actual_amount",
        key: "redemption_actual_amount",
        render: (v) => `₹${Number(v || 0).toLocaleString()}`,
      },
    ],
  },
  {
    title: "Remaining Value",
    children: [
      {
        title: "Units",
        dataIndex: "remaining_units",
        key: "remaining_units",
        render: (v) => Number(v || 0).toLocaleString(undefined, { minimumFractionDigits: 4 }),
      },
      {
        title: "Cost Value",
        dataIndex: "remaining_cost_value",
        key: "remaining_cost_value",
        render: (v) => `₹${Number(v || 0).toLocaleString()}`,
      },
      {
        title: "Current NAV",
        dataIndex: "latest_nav",
        key: "latest_nav",
        render: (v) => (v != null ? Number(v).toFixed(2) : "-"),
      },
      {
        title: "Current Value",
        dataIndex: "current_value",
        key: "current_value",
        render: (v) => `₹${Number(v || 0).toLocaleString()}`,
      },
    ],
  },
];
